import { X } from '@tamagui/lucide-icons';
import { SelectProps } from '@unistocks/components/select/select';
import { t } from '@unistocks/localization';
import { withFeedback } from '@unistocks/shared/utils/haptics/with-feedback';
import { ListItem } from 'tamagui';

export type ListHeaderProps = {
  onChange?: SelectProps['onChange'];
  onOpenChange?: SelectProps['onOpenChange'];
};

export const SelectHeader: React.FC<ListHeaderProps> = ({ onChange, onOpenChange }) => {
  return (
    <ListItem
      cursor="pointer"
      size={'$4'}
      gap={'$3'}
      bbw={1}
      tabIndex={0}
      accessible
      scaleIcon={1.5}
      iconAfter={<X color={'$danger'} />}
      onPressIn={withFeedback}
      onPress={() => {
        // TODO: Fix types. Should allow null when not required
        // @ts-ignore
        onChange?.(null);
        onOpenChange?.(false);
      }}
    >
      <ListItem.Text color={'$headingFont'} textAlign="center" size={'$6'} marginLeft={'$8'}>
        {t('::Clear')}
      </ListItem.Text>
    </ListItem>
  );
};

SelectHeader.displayName = 'SelectHeader';
